import { forEach } from 'lodash'

import { getUserIP } from 'utils/api'
import { getCookie } from 'utils/client/cookie'

const { TEST_ORDER } = process.env.server

// Restore legacy backend format: strip the "+7" prefix that the new
// frontend mask injects, and ensure a space between ")" and the digits
// after it. Backend expects "(999) 1234567".
const normalizePhoneForBackend = phone => {
  if (!phone) return phone

  let result = phone

  if (result.startsWith('+7')) {
    result = result.slice(2)
  }

  return result.replace(/\)(\d)/, ') $1')
}

export default async function({ cart, sales }) {
  const { personal, userGA } = cart
  const products = []

  const fbp = getCookie('_fbp')
  const fbc = getCookie('_fbc')
  const client_user_agent = window.navigator.userAgent
  const { ip } = await getUserIP()

  forEach(cart.goods, (value, key) => {
    if (value.isSubscription && value.amount) {
      products.push({
        id: sales.goods[key].subscription.id,
        quantity: cart.goods[key].amount,
      })
    } else if (!value.isSubscription && value.amount) {
      products.push({
        id: sales.goods[key].id,
        quantity: cart.goods[key].amount,
      })
    }
  })

  return {
    products,
    contact_info: {
      name: personal.name,
      email: personal.email,
      phone_code: personal.phone_code,
      phone: normalizePhoneForBackend(personal.phone),
      country: personal.country,
    },
    delivery: {
      id: personal.address.id,
      country: personal.address.country,
      locality: personal.address.locality,
      street: personal.address.street,
      house: personal.address.house,
      full_address: personal.address.full_address,
      comment: personal.address.comment,
    },
    payment_method: personal.payType,
    promo: cart.promo.errors?.errorCode ? '' : cart.promo.name,
    charge_info: {
      currency: sales.currency,
    },
    cookies: {
      SOURCE: getCookie('utm_source'),
      REFERRER: getCookie('REFERRER'),
      roistat_visit: getCookie('roistat_visit'),
      cl_uid: getCookie('cl_uid'),
    },
    is_test: TEST_ORDER,
    ga_cid: userGA,
    fbc,
    fbp,
    client_user_agent,
    client_ip_address: ip,
    check_cost: cart.sum.cost,
    unfinished_id: cart.orderIdUnfinished,
    is_offer_accepted: !!cart.personal.is_offer_accepted,
    is_marketing_accepted: !!cart.personal.is_marketing_accepted,
    is_research_accepted: !!cart.personal.is_research_accepted,
  }
}
